<div class="upload-container">
	<!-- Upload Area -->
	<div class="upload-area" (click)="!hasMedia && selectImages()">
		<div class="upload-loader-overlay" *ngIf="isSpin">
			<mat-spinner mode="indeterminate" diameter="48"></mat-spinner>
		</div>
		<div class="upload-content" *ngIf="!hasMedia">
			<mat-icon class="upload-icon">cloud_upload</mat-icon>
			<p class="upload-text">Click to upload images</p>
			<p class="upload-hint">PNG, JPG supported</p>
		</div>

		<!-- Preview Area -->
		<div class="preview-area" *ngIf="hasMedia">
			<!-- Images -->
			<div class="image-grid" *ngIf="images.length > 0">
				<div class="image-item" *ngFor="let image of images; let i = index">
					<img [src]="image.preview" [alt]="image.name" class="preview-image">
					<button mat-icon-button class="remove-btn" (click)="removeImage(i, $event)" [disabled]="image.uploading">
						<mat-icon>close</mat-icon>
					</button>
					<div class="file-name">{{image.name}}</div>
				</div>
			</div>

			<!-- Action Buttons -->
			<div class="action-buttons">
				<!-- Add More Button -->
				<div class="add-more-btn" *ngIf="canAddMore" (click)="!isSpin && selectImages(); $event.stopPropagation()">
					<mat-icon>add</mat-icon>
					<span>Add More</span>
				</div>
			</div>
		</div>
	</div>

	<!-- Hidden File Inputs -->
	<input #imageInput type="file" accept="image/*" multiple (change)="onImageSelect($event)" style="display: none">

	<!-- Error Messages -->
	<div class="error-messages" *ngIf="errors.length > 0">
		<div class="error-item" *ngFor="let error of errors">
			<mat-icon class="error-icon">error</mat-icon>
			<span>{{error}}</span>
		</div>
	</div>
</div>